import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { userTypeGetById } from '../userType.service';
import { Icon } from "@iconify/react";
import Loader from '../../../../components/loader';
import '../userType.css'

const baseUrl = process.env.REACT_APP_AZURE_IMAGE_BASE_URL
const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN

const UserTypeView = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const [userTypeData, setUserTypeData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUserTypeData();
  }, []);

  const getUserTypeData = async () => {
    try {
      const data = await userTypeGetById(id);
      setUserTypeData(data.data);
    } catch (error) {
      console.error('Error fetching user type by ID:', error);
    };
  }

  return (
    <Box>
      <Grid container alignItems={'center'}>
        <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
          <Typography style={{ fontSize: 30, fontWeight: 700 }}>User Type View</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 7.5, md: 8.5, lg: 8.5, xl: 8.5 }} textAlign={'end'}>
          <Button variant="contained" className='createBtn' type="submit" onClick={() => { setLoading(true); navigate(`/addUserType/${id}?type=edit`) }}>Edit</Button>
        </Grid>
        <Grid size={{ xs: 2, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} textAlign={'end'}>
          <Icon icon="ei:arrow-left" data-testid="back-icon" onClick={() => navigate('/userType')} width="30" height="30" className='backIcon'  />
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <Typography className='contentLeft'>User Type:</Typography>
        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
          <Typography className='contentLeft'> :</Typography>
        </Grid>
        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
          <Typography className='contentRight'>{userTypeData?.typeName ?? "-"}</Typography>
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <Typography className='contentLeft'>Short Name </Typography>
        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
          <Typography className='contentLeft'> :</Typography>
        </Grid>
        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
          <Typography className='contentRight'>{userTypeData?.shortName ?? "-"}</Typography>
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <Typography className='contentLeft'>Country </Typography>
        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
          <Typography className='contentLeft'> :</Typography>
        </Grid>
        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
          <Typography className='contentRight'>{userTypeData?.country?.name ?? "-"}  </Typography>
        </Grid>
      </Grid>

      <Grid container mt={2} alignItems="center">
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <Typography className='contentLeft'> Description </Typography>
        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
          <Typography className='contentLeft'> :</Typography>
        </Grid>
        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
          <Typography className="contentRight" component="div" dangerouslySetInnerHTML={{ __html: userTypeData?.description || "-" }} />
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <Typography className='contentLeft'> Image</Typography>
        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
          <Typography className='contentLeft'> :</Typography>
        </Grid>
        <Grid item xs={5} sm={5} md={8} lg={8} xl={8}>
          {userTypeData?.iconUrl ? (
            <img src={`${baseUrl}/${userTypeData.iconUrl}?${sasToken}`} alt="User Type Icon" width={100} height={100} onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              e.target.parentNode.textContent = '-';
            }}
            />
          ) : (
            '-'
          )}
        </Grid>

      </Grid>

      {loading && <Loader />}
    </Box>
  );
};

export default UserTypeView;
